import Typography from '@material-ui/core/Typography'
import formatNumberByLocale from '@utils/format-number-by-locale'
import intersectionBy from 'lodash/intersectionBy'
import isEmpty from 'lodash/isEmpty'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { TableViewStoreContext } from '../container/StandardTableView'

export interface ISelectionCountRowProps {
  width?: number
  maxSelectionLimit: number
  height: number
  setFilterData: any
  selectedRowsByTab: any
  showCountDetailOnly: boolean
}

const StyledContainer = styled.div<{ width: number; height: number }>`
  height: ${props => props.height + 'px'};
  width: ${props => props.width + 'px'};
  display: flex;
  align-items: center;
}
`

export const SelectionCountRow: React.FunctionComponent<ISelectionCountRowProps> = ({
  width,
  height,
  maxSelectionLimit,
  setFilterData,
  selectedRowsByTab,
  showCountDetailOnly
}) => {
  return useObserver(function useHook() {
    const { selectedRows, filteredColumns, getFilteredData, tableData } =
      React.useContext(TableViewStoreContext) as any
    const getFilteredRows = getFilteredData()
    const tableRecords = tableData ? tableData.length : 0
    const dataForApplyToSelected = intersectionBy(getFilteredRows, selectedRows, 'id')

    setFilterData && setFilterData(dataForApplyToSelected, !!getFilteredRows)

    const { t } = useTranslation()
    const countText =
      showCountDetailOnly && getFilteredRows
        ? dataForApplyToSelected.length
        : selectedRowsByTab
        ? selectedRowsByTab.length
        : selectedRows
        ? selectedRows.length
        : 0
    const appliedToRowsMessage =
      !showCountDetailOnly && !isEmpty(filteredColumns) && selectedRows.length
        ? `(Changes will be applied on ${dataForApplyToSelected.length} out of 
    ${selectedRows?.length} selected rows)`
        : ''
    return (
      <StyledContainer width={width as number} height={height}>
        <Typography>
          {formatNumberByLocale(countText)}{' '}
          {t('bb.common.label.selectedOutOf', 'selected out of ')}
          {formatNumberByLocale(
            tableRecords < maxSelectionLimit ? tableRecords : maxSelectionLimit
          )}
          {appliedToRowsMessage}
        </Typography>
      </StyledContainer>
    )
  })
}
